export default {"src":"/_next/static/media/critical-it-resources-and-applications.f3d45638.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};